module.exports = __webpack_public_path__ + "img/ziyou.fb0729d5.png";